/* Pause the native player if its FAQ answer is closed. No autoplay or video copy. */
(() => {
  if (window.solsticeCollectionTikTokBound) return;
  window.solsticeCollectionTikTokBound = true;
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || details.open) return;
    details.querySelectorAll('.collection-tiktok iframe').forEach(frame => {
      frame.contentWindow?.postMessage({ type: 'pause', 'x-tiktok-player': true }, 'https://www.tiktok.com');
    });
  }, true);
})();
